module.exports = __webpack_public_path__ + "img/background_shapes.3afd666b.png";